// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"acb33e6f","384":"50d52672","550":"a5746d6f","622":"2f61fd4f","644":"aedc853c","686":"7f043def","719":"92b7c825"}[chunkId] + ".chunk.js";
};